export default __webpack_public_path__ + "static/media/utensil.4b33cc10.svg";